import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,ViewChild,HostListener,ElementRef,ChangeDetectorRef } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable,Subject,BehaviorSubject } from "rxjs";
import { takeWhile } from "rxjs/operators";
import { format,parse,differenceInSeconds } from 'date-fns';
import addDays from 'date-fns/addDays';
import { DatePipe } from '@angular/common';
import { Workbook,Worksheet,Alignment,Borders,Fill } from 'exceljs';
import * as iconv from 'iconv-lite';
import * as FileSaver from 'file-saver';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgReportRestService
    ,FvmsDtgDriveScheduleRestService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
    ,dtgCarTypeList
    ,DriveScheduleRow
    ,DriveScheduleItem
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterSecToTime
    ,FilterDateTime
} from "src/app/shared/filter";

@Component({
    templateUrl: './dtg.report.rest.day.schedule.component.html'
    ,styleUrls: []
    ,providers: [FilterDateTime]
})
export class DtgReportRestDayScheduleComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    userGroupId:number;
    dtgTeamId:string = "";
    searchValue:string;
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    listYear:number[] = [];
    listMonth:number[] = [];
    maxDriveCnt:number = 40;
    listDriveCnt:number[] = [];//테이블에 운행 횟수
    listMinDrive:number[] = [];//운행시간 몇분제외
    listMinRest:number[] = [];//대기시간 몇분제외
    selectedYear:number = 2020;
    selectedMonth:number = 1;
    selectedDate:any;
    selectedMinDrive:number = 10;//10분 미만 제외
    selectedMinRest:number = 5;//5분 미만 제외
    listRow:DriveScheduleRow[] = [];
    dtgCarTypeList = dtgCarTypeList;
    @ViewChild('containerCard') containerCard:ElementRef;
    @ViewChild('containerListRest') containerListRest:ElementRef;
    heightContainerListRest:number = 500;

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgReportRestService:FvmsApiDtgReportRestService
        ,private fvmsDtgDriveScheduleRestService:FvmsDtgDriveScheduleRestService
        ,private changeDetectorRef:ChangeDetectorRef
        ,private filterDateTime:FilterDateTime
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        if(this.userGroupId > 100){
            this.dtgTeamId = this.currentUserInfo.teamId;
        }
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        this.companyInfo = companyInfo;
                        this.reloadListItem().then(() => {
                            this.reloadTable();
                        });
                    }
                }
            });
    }

    ngOnInit() {
        this.initSearchOption();
        this.reloadListItem().then(() => {
            this.reloadTable();
        });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
        this.changeHeightContainerListRest();
        this.changeDetectorRef.detectChanges();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // this.changeDetectorRef.detectChanges();
        this.changeHeightContainerListRest();
        this.changeDetectorRef.detectChanges();
    }

    changeHeightContainerListRest(){
        let hCard = this.containerCard.nativeElement.offsetHeight;
        let hRow = 50;// search row + scroll bar height
        let mgTop = 30 * 2;
        // console.log("changeHeightContainerListRest",hCard);
        let hNew = hCard - hRow - mgTop;
        // if(this.pChart01 && this.pChart01.nativeElement){
        //     h = this.pChart01.nativeElement.offsetHeight * 0.96;
        // }
        this.heightContainerListRest = hNew;
    }

    initSearchOption(){
        this.listYear = [];
        this.listMonth = [];
        this.listDriveCnt = [];

        for(let a=2020;a<2100;a++){
            this.listYear.push(a);
        }
        for(let a=1;a<13;a++){
            this.listMonth.push(a);
            this.listMinDrive.push(a*5);
            this.listMinRest.push(a*5);
        }
        for(let a=0;a<this.maxDriveCnt;a++){
            this.listDriveCnt.push(a);
        }

        let tmpDateInfo = this.fvmsCommonService.getDateInfo();
        if(tmpDateInfo && tmpDateInfo.fromDate){
            this.selectedYear = tmpDateInfo.fromDate.year;
            this.selectedMonth = tmpDateInfo.fromDate.month;
        }else{
            let today = new Date();
            this.selectedYear = today.getFullYear();
            this.selectedMonth = today.getMonth() + 1;
        }
    }

    getSearchInfo(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        let searchInfo = {
            companyId:this.companyInfo?.companyId || 0
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
            ,searchValue:this.searchValue
            // ,dtgRegDtDurationMin:this.selectedMinDrive
            // ,dtgIdleSecMin:this.selectedMinRest
        };
        return searchInfo;
    }

    reloadListItem(){
        let promise = new Promise<void>(async (resolve,reject) => {
            this.fvmsCommonService.setIsLoading(true);
            this.listRow = [];
            let listPromise = [];
            if(this.fvmsDtgDriveScheduleRestService.checkIndexDbSupport()){
                await this.fvmsDtgDriveScheduleRestService.initDb();
            }

            // 배차 정보를 가져와서 임시 테이블에 저장
            this.fvmsApiDtgReportRestService.getListReportRestDriveSchedule(this.getSearchInfo(),this.pagingInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(async resSchedule => {
                    if(resSchedule){
                        if(resSchedule.resultStatus === "ok"){
                            if(resSchedule.resultValue){
                                await this.fvmsDtgDriveScheduleRestService.clearTbSchedule();
                                this.fvmsDtgDriveScheduleRestService.insertListSchedule(resSchedule.resultValue)
                                    .then(async () => {
                                        // 운행 정보를 가져와서 임시 테이블에 저장
                                        let resTrip = await this.fvmsApiDtgReportRestService.getListReportRestDrive(this.getSearchInfo(),this.pagingInfo)
                                            .pipe(takeWhile(() => this.isContinue)).toPromise();
                                        // 공회전 정보를 가져와서 임시 테이블에 저장
                                        let resRest = await this.fvmsApiDtgReportRestService.getListReportRestIdle(this.getSearchInfo(),this.pagingInfo)
                                            .pipe(takeWhile(() => this.isContinue)).toPromise();

                                        if(resTrip){
                                            if(resTrip.resultStatus === "ok"){
                                                if(resTrip.resultValue){
                                                    // 각 row 에 회차별 정보 생성
                                                    await this.fvmsDtgDriveScheduleRestService.clearTbTrip();
                                                    let promiseTrip = this.fvmsDtgDriveScheduleRestService.insertListTrip(resTrip.resultValue);
                                                    listPromise.push(promiseTrip);
                                                }
                                            }
                                        }

                                        if(resRest){
                                            if(resRest.resultStatus === "ok"){
                                                if(resRest.resultValue){
                                                    await this.fvmsDtgDriveScheduleRestService.clearTbIdle();
                                                    let promiseIdle = this.fvmsDtgDriveScheduleRestService.insertListIdle(resRest.resultValue);
                                                    listPromise.push(promiseIdle);
                                                }
                                            }
                                        }

                                        Promise.all(listPromise).then((e) => {
                                            // console.log("reloadListItem","Promise.all",e);
                                            this.fvmsCommonService.setIsLoading(false);
                                            resolve();
                                        });
                                    });
                            }else{
                                resolve();
                            }
                        }else{
                            resolve();
                        }
                    }else{
                        resolve();
                    }
                }
                ,err => {
                    console.error("reloadListItem",err);
                    resolve();
                }
                ,() => {
                    this.fvmsCommonService.setIsLoading(false);
                });
        });
        return promise;
    }

    async reloadTable(){
        this.fvmsCommonService.setIsLoading(true);
        // 배차 정보를 가져온다
        let listSchedule = await this.fvmsDtgDriveScheduleRestService.findAllSchedule();
        // 배차 정보로 row 를 생성
        let listRow = await this.fvmsDtgDriveScheduleRestService.createRow(listSchedule,this.selectedMinDrive,this.selectedMinRest);
        this.listRow = listRow;
        // 운행 정보를 가져옴
        let listTrip = await this.fvmsDtgDriveScheduleRestService.findAllTrip(this.selectedMinDrive);
        // 각 row 에 회차별 정보 생성
        listRow = await this.fvmsDtgDriveScheduleRestService.addListTrip(listRow,listTrip);
        this.listRow = listRow;
        // 공회전 정보를 가져옴
        let listIdle = await this.fvmsDtgDriveScheduleRestService.findAllIdle(this.selectedMinRest);
        // 각 row 에 회차별 정보에 포함되는 공회전이 있으면 회차별 정보를 분할
        listRow = await this.fvmsDtgDriveScheduleRestService.addListRest(listRow,listIdle);
        this.listRow = listRow;
        // console.log("reloadTable",this.listRow);

        if(listRow){
            // 각 회차의 휴식 시작/종료로 배차정보 업데이트
            this.fvmsDtgDriveScheduleRestService.updateDtRest(listRow).then((listRowUpdatedRest:DriveScheduleRow[]) => {
                // 휴식시간이 검색조건보다 작으면 현재와 뒤의 운행시간을 합한다
                this.fvmsDtgDriveScheduleRestService.reRangeMinRest(listRowUpdatedRest).then((listRowReRangeMinRest:DriveScheduleRow[]) => {
                    // 운행시간이 제외시간 보다 작으면 현재와 앞의 운행시간을 합한다
                    this.fvmsDtgDriveScheduleRestService.reRangeMinTrip(listRowReRangeMinRest).then((listRowReRangeMinTrip:DriveScheduleRow[]) => {
                        // 미준수 사항 체크
                        this.fvmsDtgDriveScheduleRestService.checkValid(listRowReRangeMinTrip).then((listRowCheckValid:DriveScheduleRow[]) => {
                            this.listRow = listRowCheckValid;
                        });
                    });
                });
            });
        }
        this.fvmsCommonService.setIsLoading(false);
    }

    changeYear(e){
        this.changeDate();
        /*
        this.reloadListItem().then(() => {
            this.reloadTable();
        });
        */
    }

    changeMonth(e){
        this.changeDate();
        /*
        this.reloadListItem().then(() => {
            this.reloadTable();
        });
        */
    }

    changeMinDrive(e){
        /*
        this.reloadTable();
        */
    }

    changeMinRest(e){
      /*
      this.reloadTable();
      */
    }

    changeDate(){
        let dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
        let dtTo = new Date(this.selectedYear,this.selectedMonth,1,0,0,0,0);
        dtTo = addDays(dtTo,-1);
        let searchDateFrom = format(dtFrom,"yyyy-MM-dd 00:00:00");
        let searchDateTo = format(dtTo,"yyyy-MM-dd 23:59:59");
        this.selectedDate = {
            searchDateFrom:searchDateFrom
            ,searchDateTo:searchDateTo
        };
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItem().then(() => {
            this.reloadTable();
        });
    }

    clickSearch(){
        this.changeDate();
        this.reloadListItem().then(() => {
            this.reloadTable();
        });
    }

    hasErrSchedule(itemSchedule:any,findKey:string):boolean{
        if(itemSchedule){
            if(itemSchedule.err){
                return itemSchedule.err.hasOwnProperty(findKey);
            }
        }
        return false;
    }

    hasErrRest(itemSchedule:any,idx:number):boolean{
        if(itemSchedule.listDrive){
            let itemDrive = itemSchedule.listDrive[idx];
            if(itemDrive){
                if(itemDrive.err){
                    for(let key in itemDrive.err){
                        if(itemDrive.err.hasOwnProperty(key)) return true;
                    }
                }
            }
        }
        return false;
    }

    getRestErrMsg(itemSchedule:any,idx:number):string{
        if(itemSchedule.listDrive){
            let itemDrive = itemSchedule.listDrive[idx];
            if(itemDrive){
                if(itemDrive.msg){
                    let msg = "";
                    for(let key in itemDrive.msg){
                        msg += itemDrive.msg[key];
                    }
                    return msg;
                }
            }
        }
        return "";
    }

    exportExcel(){
        let listRow = this.listRow;
        if(listRow || listRow.length > 0){
            let wb = new Workbook();
            let ws:Worksheet = wb.addWorksheet("Sheet1");
            this.createExcelHeader(ws).then(() => {
                this.createExcelBody(ws).then(() => {
                    const dtFrom = new Date(this.selectedYear,this.selectedMonth - 1,1,0,0,0,0);
                    const searchDateFrom = format(dtFrom,"yyyyMM");
                    let fileName = "";
                    fileName += "운수종사자_휴식시간_보장_내역_통보서";
                    fileName += "-";
                    fileName += this.companyInfo.companyNm;
                    fileName += "-";
                    fileName += searchDateFrom;
                    fileName += "-";
                    fileName += new Date().getTime();
                    fileName += ".xlsx";

                    wb.xlsx.writeBuffer().then((data) => {
                        // let blob = new Blob([iconv.encode(data,"euc-kr")],{ type: "application/octet-stream;"});
                        let blob = new Blob([data],{ type: "application/octet-stream;"});
                        FileSaver.saveAs(blob,fileName);
                    });
                });
            });
        }
    }

    createCellLetter(ws:Worksheet, cell:string, mergeCell:string, value: string, font:Object = undefined, alignCenter:Alignment = undefined, border: Borders = undefined, fill: Fill = undefined) {
        ws.mergeCells(mergeCell);
        let cellObj  = ws.getCell(cell);
        cellObj.value=value;
        if(font)
            cellObj.font = font;
        if(alignCenter)
            cellObj.alignment = alignCenter;
        if(border)
            cellObj.border = border;
        if(fill)
            cellObj.fill = fill;
        return cellObj
    }

    createCellByNum(ws:Worksheet,rowHead:number,colHead:number, value: string, font:Object = undefined, alignCenter:Alignment = undefined, border: Borders = undefined, fill: Fill = undefined, noMergeCell:boolean= false ) {
        if(!noMergeCell) {
            ws.mergeCells(rowHead,colHead,rowHead,colHead +1);
        }
        let cellObj = ws.getCell(rowHead,colHead);
        cellObj.value=value;
        if(font)
            cellObj.font = font;
        if(alignCenter)
            cellObj.alignment = alignCenter;
        if(border)
            cellObj.border = border;
        if(fill)
            cellObj.fill = fill;
        return cellObj
    }

    createRow(ws:Worksheet, rowIndexFrom: number, rowIndexTo: number, value: any, align:Alignment = undefined) {
        const cell = ws.getCell(rowIndexFrom,rowIndexTo);
        cell.value = value;
        if(align) cell.alignment = align;
    }

    createExcelHeader(ws:Worksheet){
        let promise = new Promise<void>((resolve) => {
            let font = {
                name:"Arial"
                ,size:10
            };
            let alignCenter = {
                wrapText: true,
                vertical:'middle'
                ,horizontal:'center'
            } as Alignment;
            let alignLeft = {
                wrapText: true,
                vertical:'middle'
                ,horizontal:'left'
            } as Alignment;
            let styleBorder = {style:'thin',color:{argb:"343a4000"}};
            let border = {
                top:styleBorder
                ,bottom:styleBorder
                ,left:styleBorder
                ,right:styleBorder
            } as Borders;
            let styleBgCyan:Fill = {
                type:'pattern'
                ,pattern:'solid'
                ,fgColor:{argb:'0000FFFF'}
                // ,bgColor:{argb:'4000FF00'}
            };
            const left_head = [
                '* 시작일자 : 서식 텍스트 8자리 예) 20181001 [2018년 10월 01일]',
                '* 시작시간 : 서식 텍스트 4자리 예) 0830 [오전 8시30분] 0024 [밤 12시24분]',
                '* 종료일자 : 서식 텍스트 8자리 예) 20181001 [2018년 10월 01일]',
                '* 종료시간 : 서식 텍스트 4자리 예) 0830 [오전 8시30분]',
                '* 운행 : 서식 텍스트 3자리 예) 135 [135분]',
                '* 휴식 : 서식 텍스트 3자리 예) 74 [74분]',
                '* 운행상태 : 서식 텍스트 입력 운행/미운행 (기본 : 운행)',
                '* 미운행이 한건이라도 등록된 운수종사자는 해당 월 전체 미운행처리 됩니다.'
            ]
            const right_head = [
                '※ 휴식시간 준수 기준',
                '1. 시내, 농어촌, 마을버스',
                '1) 각 회차 종료 후 10분 이상 휴식 보장',
                '2) 회차 운행시간 2시간 이상일 경우 15분 이상 휴식 보장',
                '3) 회차 운행시간 4시간 이상일 경우 30분 이상 휴식 보장',
                '2. 시외(고속)버스/전세버스',
                '1) 각 회차 종료 후 15분 이상 휴식 보장',
                '2) 회차 운행시간 3시간 이상일 경우 30분 이상 휴식 보장',
                '3. 전체 : 운행 종료시간과 운행 시작시간 사이 8시간(광역급행 및 직행좌석형 시내버스의 경우 10시간) 이상 휴식 보장',
            ]
            const subtitle = [
                '* 서식 다운로드 시점을 기준으로 해당 월의 재직운전자를 추출한 목록입니다. 실재 재직자와 상이할 경우 입퇴사 등록 여부를 확인해 주십시오.',
                '* 해당 월의 운수종사자가 미운행 상태인 경우 운행상태 컬럼을 미운행 상태로 텍스트 변경하여 엑셀업로드 하여 주십시오.'
            ]
            for(let i=1;i<=left_head.length;i++) {
                this.createCellLetter(ws, 'A'+i, 'A'+i+':H'+i, left_head[i-1], font);
            }
            for(let i=1;i<=right_head.length;i++) {
                this.createCellLetter(ws, 'J'+i, 'J'+i+':AD'+i, right_head[i-1], font);
            }
            let currentRow = 10
            for(let i=1;i<=subtitle.length;i++) {
                this.createCellLetter(ws,  'A'+(currentRow+i), 'A'+(currentRow+i)+':BA'+(currentRow+i), subtitle[i-1], font);
            }
            currentRow = 13
            // 운수회사명
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '운수회사명', font, alignCenter, border, styleBgCyan);
            // companyNm
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':I'+currentRow, this.companyInfo.companyNm, font, alignCenter, border, styleBgCyan);
            // 대표자성명
            this.createCellLetter(ws, 'J'+currentRow, 'J'+currentRow+':K'+currentRow, "대표자성명", font, alignCenter, border, styleBgCyan);            
            // companyNm
            this.createCellLetter(ws, 'L'+currentRow, 'L'+currentRow+':BA'+currentRow, this.companyInfo.companyNm, font, alignCenter, border, styleBgCyan);

            currentRow = 14
            // 법인등록번호
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '법인등록번호', font, alignCenter, border, styleBgCyan);
            // companyNm
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':I'+currentRow, this.companyInfo.tid, font, alignCenter, border, styleBgCyan);
            // 사업자등록번호
            this.createCellLetter(ws, 'J'+currentRow, 'J'+currentRow+':K'+currentRow, "사업자등록번호", font, alignCenter, border, styleBgCyan);            
            // companyNm
            this.createCellLetter(ws, 'L'+currentRow, 'L'+currentRow+':BA'+currentRow, this.companyInfo.dtgEid, font, alignCenter, border, styleBgCyan);

            currentRow = 15
            // 면허정보
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '면허정보', font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':BA'+currentRow, "", font, alignCenter, border);

            currentRow = 16
            // 주소
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '주소', font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':BA'+currentRow, "", font, alignCenter, border);

            currentRow = 17
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, "", font, alignCenter, border, styleBgCyan);
            // 대상운전자
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':D'+currentRow, '대상운전자', font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'E'+currentRow, 'E'+currentRow+':I'+currentRow, "", font, alignLeft, border);
            // 면허대수
            this.createCellLetter(ws, 'J'+currentRow, 'J'+currentRow+':K'+currentRow, "면허대수", font, alignCenter, border, styleBgCyan);            
            this.createCellLetter(ws, 'L'+currentRow, 'L'+currentRow+':M'+currentRow, "", font, alignLeft, border);         
            // 보유대수
            this.createCellLetter(ws, 'N'+currentRow, 'N'+currentRow+':S'+currentRow, "보유대수", font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'T'+currentRow, 'T'+currentRow+':BA'+currentRow, "", font, alignLeft, border);
           
            currentRow = 18
            // 계
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '계', font, alignCenter, border, styleBgCyan);
            // 대상운전자
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':D'+currentRow, '대상운전자', font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'E'+currentRow, 'E'+currentRow+':I'+currentRow, "", font, alignLeft, border);
            // 면허대수
            this.createCellLetter(ws, 'J'+currentRow, 'J'+currentRow+':K'+currentRow, "면허대수", font, alignCenter, border, styleBgCyan);            
            this.createCellLetter(ws, 'L'+currentRow, 'L'+currentRow+':M'+currentRow, "", font, alignLeft, border);         
            // 보유대수
            const cellN18 = this.createCellLetter(ws, 'N'+currentRow, 'N'+currentRow+':S'+currentRow, "보유대수", font, alignCenter, border, styleBgCyan);
            ws.getColumn(cellN18.col).width = 2
            this.createCellLetter(ws, 'T'+currentRow, 'T'+currentRow+':BA'+currentRow, "", font, alignLeft, border);
           
            currentRow = 19
            // 주소
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':B'+currentRow, '노선수', font, alignCenter, border, styleBgCyan);
            this.createCellLetter(ws, 'C'+currentRow, 'C'+currentRow+':BA'+currentRow, "", font, alignCenter, border);

            currentRow = 21
            // 운수종사자 정보
            this.createCellLetter(ws, 'A'+currentRow, 'A'+currentRow+':H'+currentRow, '운전자정보', font, alignCenter, border, styleBgCyan);
            // 운행정보
            this.createCellLetter(ws, 'I'+currentRow, 'I'+currentRow+':M'+currentRow, '운행정보', font, alignCenter, border, styleBgCyan);
            // 운행 및 휴식시간 내역(분)
            this.createCellLetter(ws, 'N'+currentRow, 'N'+currentRow+':CO'+currentRow, '운행 및 휴식시간 내역(분)', font, alignCenter, border, styleBgCyan);

            currentRow = 22
            const tbHeader = {
                A:'운수회사\r\n코드',
                B:'운전자ID',
                C:'운수회사명',
                D:'생년월일',
                E:'성명',
                F:'입사일자',
                G:'운송구분',
                H:'노선번호 및\r\n노선명(기점-종점)',
                I:'운행상태',
                J:'시작일자',
                K:'시작시간',
                L:'종료일자',
                M:'종료시간',
            }             
            for (const [key, value] of Object.entries(tbHeader)) {
                const cell = this.createCellLetter(ws, key+currentRow, key+currentRow+':'+key+(currentRow+1), value, font, alignCenter, border, styleBgCyan);
                if(key === 'H') {
                    ws.getColumn(cell.col).width = 40
                }
            }
            let sizeList = this.listDriveCnt.length;
            let rowBaseHead = currentRow;
            let colBaseHead = 14;
            for(let a=0;a<sizeList;a++){
                this.createCellByNum(ws, rowBaseHead, colBaseHead + (a * 2), `${a+1}회` , font, alignCenter, border, styleBgCyan);
                const opter = this.createCellByNum(ws, rowBaseHead + 1, colBaseHead + (a * 2), '운행' , font, alignCenter, border, styleBgCyan, true);
                ws.getColumn(opter.col).width = 4
                const rest = this.createCellByNum(ws, rowBaseHead + 1, colBaseHead + (a * 2) + 1, '휴식' , font, alignCenter, border, styleBgCyan, true);
                ws.getColumn(rest.col).width = 4
            }
            resolve();
        });
        return promise;
    }

    createExcelBody(ws:Worksheet){
        let promise = new Promise<void>((resolve) => {
            let listRow = this.listRow;
            if(listRow){
                let alignCenter = {
                    vertical:'middle'
                    ,horizontal:'center'
                } as Alignment;
                for(let a=0;a<listRow.length;a++){
                    let itemRow = listRow[a];
                    let idxCellRow = 24 + a;
                    let idxCellCol = 1;
                    this.createRow(ws, idxCellRow, idxCellCol++, itemRow.ccd, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, itemRow.drvKotsaDriverId, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, itemRow.companyNm, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.userBirthDt,"yyyyMMdd"), alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, itemRow.userNm, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.userHireDt,"yyyyMMdd"), alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, itemRow.dtgCarTypeNm, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, `${itemRow.drivePathNm} (${itemRow.drivePathFromNm} - ${itemRow.drivePathToNm})`, alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, '운행', alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.getDtFromRowTxt(),"yyyyMMdd"), alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.getDtFromRowTxt(),"HHmm"), alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.getDtToRowTxt(),"yyyyMMdd"), alignCenter)
                    this.createRow(ws, idxCellRow, idxCellCol++, this.filterDateTime.transform(itemRow.getDtToRowTxt(),"HHmm"), alignCenter)
                    //Operation & Rest
                    for(let b=0;b<this.listDriveCnt.length;b++){
                        this.createRow(ws, idxCellRow, idxCellCol + (b * 2), itemRow.getDurMinuteTrip(b), alignCenter)
                        this.createRow(ws, idxCellRow, idxCellCol + (b * 2) + 1, itemRow.getDurMinuteRest(b), alignCenter)
                    }
                }
            }
            resolve();
        });
        return promise;
    }
}
